import { render } from "./vehicle-search-component.vue?vue&type=template&id=5c62cc36"
import script from "./vehicle-search-component.vue?vue&type=script&lang=js"
export * from "./vehicle-search-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__